import Typography from '@mui/material/Typography';
import { HighlightedPhrase } from '@openx/components-core/lib/HighlightedPhrase/HighlightedPhrase';
import { ValuePlaceholder } from '@openx/components-core/lib/Value/ValuePlaceholder/ValuePlaceholder';

export const HighlightedCell = ({ value, phrase }: { value?: string | null; phrase: string }) => {
  return value ? (
    <Typography color="textSecondary" component="span" variant="body2">
      <HighlightedPhrase searchPhrase={phrase}>{value}</HighlightedPhrase>
    </Typography>
  ) : (
    <ValuePlaceholder />
  );
};
